<template lang="pug">
	.download-button(@click="$emit('click')")
		IconDownload.icon-download
		p.button-text Download
</template>

<script>
import IconDownload from '@/components/IconDownload';

export default {
  name       : 'download-button',
  components : {
    IconDownload
  }
};
</script>

<style lang="scss" scoped>
.download-button {
	display: flex;
	align-items: center;
	color: #1C4587;
	cursor: pointer;

	.icon-download {
		width: 12px;
		margin-right: 10px;
	}

	.button-text {
		font-weight: 500;
	}
}

// .download {
// 	font-weight: 600;
// 	font-size: 12px;
// 	line-height: 14px;
// 	letter-spacing: -.03em;
// 	color: $ypDownload;
// 	display: flex;
// 	cursor: pointer;
// 	.spanWrapper {
// 		height: 12px;
// 		width: 10px;
// 		position: relative;
// 		margin-right: 7px;
// 		border-bottom: 2px solid $ypDownload;
// 		span {
// 			content: '';
// 			width: 2px;
// 			height: 8px;
// 			background-color: $ypDownload;
// 			position: absolute;
// 			bottom: 2px;
// 			left: 4px;
// 			border-radius: 25px;
// 			&::before,
// 			&::after {
// 				content: '';
// 				width: 2px;
// 				height: 5px;
// 				background-color: $ypDownload;
// 				position: absolute;
// 				border-radius: 25px;
// 			}
// 			&::before {
// 				transform: translate( 2px, 3px ) rotate(45deg);
// 			}
// 			&::after {
// 				transform: translate( -2px, 3px ) rotate(-45deg);
// 			}
// 		}
// 	}
// }
</style>
